import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import { contrastColor, getColor, lightOrDark } from './constants/constants';
import moment from 'moment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MarwisService {
  private http = inject(HttpClient);

  gmaData = {};
  loading = false;
  private url = environment.url.bff;

  public getMarwisData(marwisId: number, month?): Promise<Array<any>> {
    return new Promise(resolve => {
      let parameter = '';
      if (month) {
        const dtgStart =
          moment(month + 'T00:00:00')
            .subtract(moment(month + 'T00:00:00').utcOffset(), 'minutes')
            .format('YYYY-MM-DDTHH:00:00') + 'Z';
        const dtgEnd =
          moment(month + 'T00:00:00')
            .add(1, 'month')
            .subtract(
              moment(month + 'T00:00:00')
                .add(1, 'month')
                .utcOffset(),
              'minutes'
            )
            .format('YYYY-MM-DDTHH:00:00') + 'Z';
        parameter = '?dtgStart=' + dtgStart + '&dtgEnd=' + dtgEnd;
      }
      try {
        this.getMarwisDataFromBFF(marwisId, parameter).subscribe(
          data => {
            if (data.hasOwnProperty('stations')) {
              if (data['stations'].length > 0) {
                if (data['stations'][0].hasOwnProperty('timeseries')) {
                  const timeItems = data['stations'][0].timeseries.timeItems;
                  timeItems.sort((a, b) =>
                    a.dtg > b.dtg ? 1 : b.dtg > a.dtg ? -1 : 0
                  );
                  const returnArray = [];
                  for (const index in timeItems) {
                    if (timeItems.hasOwnProperty(index)) {
                      returnArray.push(timeItems[index]);
                    }
                  }

                  resolve(returnArray);
                }
              }
            }
            resolve(null);
          },
          err => {
            resolve([]);
          }
        );
      } catch (e) {
        resolve([]);
      }
    });
  }

  getGmaData(stationInfo: any, from: string, to: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const stationId = stationInfo.stationId;
      let fullUrl = this.url + '/smw/' + stationId;
      fullUrl +=
        '?dtgStart=' +
        moment(from).subtract(30, 'minutes').utc().format() +
        '&dtgEnd=' +
        moment(to).add(30, 'minutes').utc().format();
      this.http.get(fullUrl).subscribe(
        data => {
          if (data !== undefined) {
            this.gmaData[stationId] = {
              station: stationInfo,
              data: data['stations'][0].timeseries.timeItems,
            };
          }
          resolve();
        },
        error => reject(error)
      );
    });
  }

  getColor(parameter, value): string {
    return getColor(parameter, value);
  }

  contrastColor(parameter, value): string {
    return contrastColor(parameter, value);
  }

  lightOrDark(color: string): string {
    return lightOrDark(color);
  }

  private getMarwisDataFromBFF(
    marwisId: number,
    parameter: string
  ): Observable<any> {
    const fullUrl = this.url + '/marwis/' + marwisId + parameter;
    return this.http.get(fullUrl);
  }
}
